import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import {
    Toolbar,
    ToolbarButton,
    ColumnsPanelTrigger,
    FilterPanelTrigger,
} from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import FilterListIcon from '@mui/icons-material/FilterList';
import Divider from '@mui/material/Divider';
import { Button, IconButton, useMediaQuery } from '@mui/material';
import AccessAlarmsOutlinedIcon from '@mui/icons-material/AccessAlarmsOutlined';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppSettingsContextProvider';
import FilterEventsButtons from './FilterEventsButtons';
import AddIcon from '@mui/icons-material/Add';
import FilterEventsButtonsMobile from './FilterEventsButtonsMobile';

interface ToolbarProps {
    onFilterChange: (filter: string) => void;
}

declare module '@mui/x-data-grid' {
    interface ToolbarPropsOverrides {
        onFilterChange: (filter: string) => void
        showSearchFilterButton: boolean
    }
}

export function CustomToolbar({ onFilterChange }: ToolbarProps) {
    const theme = useTheme();
    const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
    const { showToDateExpired, setShowToDateExpired } = useAppContext();
    const navigate = useNavigate();

    return (
        <Toolbar>
            <Button
                sx={{
                    fontWeight: "bold",
                    fontSize: "16px",
                }}
                variant="contained"
                color="primary"
                size="small"
                onClick={() => navigate("/events/create")}
            >
                <AddIcon fontSize="small" />
                Ny
            </Button>

            <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 0.5 }} />

            {!isSmDown && (
                <>
                    <FilterEventsButtons
                        onFilterChange={onFilterChange}
                    />
                </>
            )}
            {isSmDown && (

                <FilterEventsButtonsMobile
                    onFilterChange={onFilterChange}
                />
            )}

            <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 0.5 }} />

            <Tooltip title={showToDateExpired ? "Skjul utgåtte" : "Vis utgåtte"}>
                <IconButton
                    size="small"
                    onClick={() => setShowToDateExpired((prev) => !prev)}
                    sx={{
                        fontWeight: "bold",
                        fontSize: "16px",
                        backgroundColor: "transparent",
                    }}
                >
                    {showToDateExpired
                        ? <AccessAlarmsOutlinedIcon color="warning" />
                        : <AccessAlarmsOutlinedIcon color="primary" />
                    }
                </IconButton>
            </Tooltip>
            <Tooltip title="Kolonner">
                <ColumnsPanelTrigger render={<ToolbarButton />}>
                    <ViewColumnIcon fontSize="small" />
                </ColumnsPanelTrigger>
            </Tooltip>

            <Tooltip title="Filtrer">
                <FilterPanelTrigger
                    render={(props, state) => (
                        <ToolbarButton {...props} color="default">
                            <Badge badgeContent={state.filterCount} color="primary" variant="dot">
                                <FilterListIcon fontSize="small" />
                            </Badge>
                        </ToolbarButton>
                    )}
                />
            </Tooltip>
        </Toolbar>
    );
}